import { Link } from 'react-router-dom';
import { clsx } from 'clsx';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  linkTo?: string;
}

export function Logo({ size = 'md', className, linkTo = '/' }: LogoProps) {
  const sizeClasses = {
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-xl',
  };

  const iconSizes = {
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-7 h-7',
  };

  const isClickable = !!linkTo;

  const LogoContent = (
    <div className={clsx(
      'font-medium tracking-tight flex items-center gap-2',
      sizeClasses[size],
      isClickable && 'cursor-pointer',
      className
    )}>
      <img
        src="/octoverdict-no-bg.png"
        alt="Vettis"
        className={clsx(iconSizes[size], 'object-contain')}
      />
      <span className="text-verdict-primary/70">Vettis</span>
    </div>
  );

  if (linkTo) {
    return (
      <Link to={linkTo} className="inline-block hover:opacity-90 transition-opacity cursor-pointer">
        {LogoContent}
      </Link>
    );
  }

  return LogoContent;
}

